import AllhomesBrowseSuburb from './allhomes-browse-suburb';
export default AllhomesBrowseSuburb;